<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="create_db">
      {{ $t('db.database.button.create') }}
    </i-button>

    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import FilterComponent from '@db/components/db/db-table-filter';
  import TableComponent from '@db/components/db/db-table';
  import { DataBaseModalService } from '@db/modals/DataBaseModalService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterComponent,
      TableComponent
    },

    methods: {
      ...mapActions('db/databases/table', ['getAsyncData']),

      create_db: function () {
        DataBaseModalService.create().on('success', () => this.getAsyncData({ current_page: 1 }));
      }
    }
  };
</script>
